export const relationListCompra = [
  { label: "% ICMS Crédito", value: "tributosIcmsAliquota", tipo: "PORCENTAGEM" },
  { label: "ICMS Desonerado", value: "icmsDesoneradoCompra", tipo: "DECIMAL" },
  { label: "% Frete", value: "freteCompra", tipo: "PORCENTAGEM" },
  { label: "% IPI", value: "tributosIpiAliquota", tipo: "PORCENTAGEM" },
  { label: "% ICMS Redução", value: "icmsReducaoCompra", tipo: "PORCENTAGEM" },
  { label: "% ICMS", value: "icmsCompra", tipo: "PORCENTAGEM" },
  { label: "% PIS Crédito", value: "pisCreditoCompra", tipo: "PORCENTAGEM" },
  { label: "% COFINS Crédito", value: "cofinsCreditoCompra", tipo: "PORCENTAGEM" },
  { label: "% Custo Administrativo", value: "custoAdmCompra", tipo: "PORCENTAGEM" },
  { label: "% PIS Antecipado Crédito", value: "pisAntCredCompra", tipo: "PORCENTAGEM" },
  { label: "% COFINS Antecipado Crédito", value: "cofinsAntCredCompra", tipo: "PORCENTAGEM" },
  { label: "% Desconto Antecipado", value: "descontoAntCompra", tipo: "PORCENTAGEM" },
  { label: "% Antecipação Parcial", value: "antParcCompra", tipo: "PORCENTAGEM" },
  { label: "% ICMS ST", value: "icmsStCompra", tipo: "PORCENTAGEM" },
  { label: "% ICMS Crédito", value: "icmsCreditoStCompra", tipo: "PORCENTAGEM" },
  { label: "% MVA", value: "mvaStCompra", tipo: "PORCENTAGEM" },
  { label: "% ICMS Débito", value: "icmsDebitoStCompra", tipo: "PORCENTAGEM" },
  { label: "% ICMS Substituição", value: "icmsSubsCompra", tipo: "PORCENTAGEM" },
  { label: "% FCP ST", value: "fcpStCompra", tipo: "PORCENTAGEM" },
];

export const relationListVenda = [
  { label: "% ICMS Débito", value: "icmsDebitoVenda" },
  { label: "% IPI", value: "ipiVenda" },
  { label: "% ICMS Redução", value: "icmsReducaoVenda" },
  { label: "% Custo Administrativo", value: "custoAdmVenda" },
  { label: "% PIS", value: "pisVenda" },
  { label: "% COFINS", value: "cofinsVenda" },
  { label: "% Imposto de Renda", value: "impostoRendaVenda" },
  { label: "% Contribuição Social", value: "contSocialVenda" },
  { label: "% Supersimples", value: "supersimplesVenda" },
  { label: "% Comissão", value: "comissaoVenda" },
];
